/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResponseAppVersionResponse } from '../backend/model';
// @ts-ignore
import type { UpdateAppVersionRequest } from '../backend/model';
/**
 * CouncilAppVersionApi - axios parameter creator
 * @export
 */
export const CouncilAppVersionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the mobile app version policy, including minimum version, optional soft-update threshold, deprecation flag, maintenance copy, and store URLs.
         * @summary Get app version for a specific council
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilAppVersion: async (councilId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getCouncilAppVersion', 'councilId', councilId)
            const localVarPath = `/api/council/{councilId}/app-version`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the mobile app version policy, including force-update threshold, optional soft-update threshold, deprecation flag, maintenance copy, and store URLs.
         * @summary Update app version for a specific council
         * @param {string} councilId 
         * @param {UpdateAppVersionRequest} updateAppVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouncilAppVersion: async (councilId: string, updateAppVersionRequest: UpdateAppVersionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('updateCouncilAppVersion', 'councilId', councilId)
            // verify required parameter 'updateAppVersionRequest' is not null or undefined
            assertParamExists('updateCouncilAppVersion', 'updateAppVersionRequest', updateAppVersionRequest)
            const localVarPath = `/api/council/{councilId}/app-version`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAppVersionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouncilAppVersionApi - functional programming interface
 * @export
 */
export const CouncilAppVersionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouncilAppVersionApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the mobile app version policy, including minimum version, optional soft-update threshold, deprecation flag, maintenance copy, and store URLs.
         * @summary Get app version for a specific council
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouncilAppVersion(councilId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseAppVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouncilAppVersion(councilId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAppVersionApi.getCouncilAppVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the mobile app version policy, including force-update threshold, optional soft-update threshold, deprecation flag, maintenance copy, and store URLs.
         * @summary Update app version for a specific council
         * @param {string} councilId 
         * @param {UpdateAppVersionRequest} updateAppVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCouncilAppVersion(councilId: string, updateAppVersionRequest: UpdateAppVersionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseAppVersionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCouncilAppVersion(councilId, updateAppVersionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CouncilAppVersionApi.updateCouncilAppVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CouncilAppVersionApi - factory interface
 * @export
 */
export const CouncilAppVersionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouncilAppVersionApiFp(configuration)
    return {
        /**
         * Returns the mobile app version policy, including minimum version, optional soft-update threshold, deprecation flag, maintenance copy, and store URLs.
         * @summary Get app version for a specific council
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilAppVersion(councilId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseAppVersionResponse> {
            return localVarFp.getCouncilAppVersion(councilId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the mobile app version policy, including force-update threshold, optional soft-update threshold, deprecation flag, maintenance copy, and store URLs.
         * @summary Update app version for a specific council
         * @param {string} councilId 
         * @param {UpdateAppVersionRequest} updateAppVersionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouncilAppVersion(councilId: string, updateAppVersionRequest: UpdateAppVersionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseAppVersionResponse> {
            return localVarFp.updateCouncilAppVersion(councilId, updateAppVersionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CouncilAppVersionApi - object-oriented interface
 * @export
 * @class CouncilAppVersionApi
 * @extends {BaseAPI}
 */
export class CouncilAppVersionApi extends BaseAPI {
    /**
     * Returns the mobile app version policy, including minimum version, optional soft-update threshold, deprecation flag, maintenance copy, and store URLs.
     * @summary Get app version for a specific council
     * @param {string} councilId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAppVersionApi
     */
    public getCouncilAppVersion(councilId: string, options?: RawAxiosRequestConfig) {
        return CouncilAppVersionApiFp(this.configuration).getCouncilAppVersion(councilId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the mobile app version policy, including force-update threshold, optional soft-update threshold, deprecation flag, maintenance copy, and store URLs.
     * @summary Update app version for a specific council
     * @param {string} councilId 
     * @param {UpdateAppVersionRequest} updateAppVersionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouncilAppVersionApi
     */
    public updateCouncilAppVersion(councilId: string, updateAppVersionRequest: UpdateAppVersionRequest, options?: RawAxiosRequestConfig) {
        return CouncilAppVersionApiFp(this.configuration).updateCouncilAppVersion(councilId, updateAppVersionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

